import { DTO__generation } from '@shared/dto/generation/DTO__generation';
import { DTO__token } from '@shared/dto/generation/settings/token/DTO__token';
import { WritableDraft } from 'immer';

export const get_entity_with_sorted_tokens_generation = (target: DTO__generation | WritableDraft<DTO__generation>) => {
  let tokens = target.settings.tokens.sort(DTO__token.sortByWordTranslated);

  return target.clone({
    settings: target.settings.clone({ tokens }),
  });
};
